import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertFloat'
})
export class ConvertFloatPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    const num = Math.floor(value * 100) / 100 ;
    const arr = num.toString().split('.');
    if ( arr.length === 1){
      value = num.toString() + '.00';
      return value;
    }
    if ( arr.length > 1){
    if (arr[1].length < 2){
    value = num.toString() + '0';
    }else{
      value = num;
    }
    return value;
    }
  }

}
